import * as consts from 'config/consts';
import { AccountType } from './accountType';

// memo: 旧NISA→NISA、iDeco→企業型にaccountType自体を変換する処理
export const getConvertedAccountType = (accountType: number): AccountType => {
  if (accountType === consts.AccountType.旧NISA) {
    return consts.AccountType.NISA;
  } else if (accountType === consts.AccountType.iDeCo) {
    return consts.AccountType.企業型;
  } else {
    return accountType as AccountType;
  }
};

export const getTradeTypeName = (tradeType: number, side: number): string => {
  switch (tradeType) {
    case consts.TradeType.なし:
      return side === consts.Side.買
        ? '買'
        : side === consts.Side.売
        ? '売'
        : '';
    case consts.TradeType.新規:
      return '新規';
    case consts.TradeType.返済:
      return '決済';
    case consts.TradeType.現引:
      return '現引き';
    case consts.TradeType.現渡:
      return '現渡';
    default:
      return '';
  }
};

export const getCashMarginName = (cashMargin: number): string => {
  switch (cashMargin) {
    case consts.CashMargin.現物:
      return '現物';
    case consts.CashMargin.信用:
      return '信用';
    default:
      return '';
  }
};

export const getSideName = (side: number): string => {
  switch (side) {
    case consts.Side.買:
      return '買い';
    case consts.Side.売:
      return '売り';
    default:
      return '';
  }
};
export const getSideName2 = (side: number): string => {
  switch (side) {
    case consts.Side.買:
      return '買';
    case consts.Side.売:
      return '売';
    default:
      return '';
  }
};
export const getSideName3 = (side: number): string => {
  switch (side) {
    case consts.Side.買:
      return '買付';
    case consts.Side.売:
      return '売却';
    default:
      return '';
  }
};

export const getExchangeName = (exchange: number | undefined): string => {
  switch (exchange) {
    case consts.Exchange.東証:
      return '東証';
    case consts.Exchange.名証:
      return '名証';
    case consts.Exchange.福証:
      return '福証';
    case consts.Exchange.札証:
      return '札証';
    case consts.Exchange.大証:
      return '大証';
    default:
      return '';
  }
};

export const getDate = (date: number): Date => {
  const year = Math.floor(date / 10000);
  const month = Math.floor((date - year * 10000) / 100);
  const day = date - year * 10000 - month * 100;

  return new Date(year, month - 1, day);
};

export const getAggregateSourceName = (aggregateSource: number): string => {
  switch (aggregateSource) {
    case consts.AggregateSourceTypes.テコテック:
      return 'みんかぶ口座連携(旧)';
    case consts.AggregateSourceTypes.MONO:
      return 'みんかぶ口座連携';
    case consts.AggregateSourceTypes.マネーツリー:
      return 'マネーツリー連携';
    case consts.AggregateSourceTypes.手入力:
      return '直接入力';
    default:
      return '';
  }
};

export const convertToMonoBrokerId = (brokerID: string): string => {
  switch (brokerID) {
    case consts.TecotecBrokerIds.SBI証券:
    case consts.MoneytreeBrokerIds.SBI証券:
      return consts.MONOBrokerIds.SBI証券;
    case consts.TecotecBrokerIds.楽天証券:
    case consts.MoneytreeBrokerIds.楽天証券:
      return consts.MONOBrokerIds.楽天証券;
    case consts.TecotecBrokerIds.松井証券:
    case consts.MoneytreeBrokerIds.松井証券:
      return consts.MONOBrokerIds.松井証券;
    case consts.TecotecBrokerIds.三菱UFJeスマート証券:
    case consts.MoneytreeBrokerIds.三菱UFJeスマート証券:
      return consts.MONOBrokerIds.三菱UFJeスマート証券;
    default:
      return '';
  }
};

export const isMONOBrokerId = (brokerId: string): boolean => {
  return consts.brokerIDsToArray(consts.MONOBrokerIds).includes(brokerId);
};

export const brokerIDToName = (brokerID: string): string | null => {
  if (brokerID === '1100') return 'MINKABU ROBO';
  if (brokerID === 'wealthnavi') return 'WealthNavi';
  if (brokerID === 'theo') return 'THEO';
  return null;
};
